var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 44,
    fill: "none",
    viewBox: "0 0 42 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M3.16971 21.9494C3.07352 21.6182 3.10301 21.2631 3.25254 20.9522L9.05489 8.88896C9.41616 8.13788 10.3496 7.86684 11.0569 8.30761L22.4179 15.387C22.7107 15.5694 22.9258 15.8535 23.022 16.1847L28.9117 36.4674C29.1273 37.2099 28.7001 37.9867 27.9576 38.2023L10.7943 43.1862C10.0517 43.4018 9.275 42.9746 9.05939 42.2321L3.16971 21.9494Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    fillRule: "evenodd",
    d: "M9.56421 22.756C9.61309 23.2449 9.83181 23.7011 10.1823 24.0453L25.8399 39.4234C26.6673 40.2361 27.9969 40.2242 28.8096 39.3967L40.3519 27.6446C41.1646 26.8172 41.1527 25.4876 40.3252 24.6749L24.6676 9.29677C24.3171 8.95253 23.857 8.74207 23.3674 8.702L10.545 7.65265C9.23791 7.54568 8.15363 8.64966 8.28412 9.9546L9.56421 22.756ZM15.899 15.1721C16.699 14.3575 16.6873 13.0487 15.8727 12.2487C15.0582 11.4487 13.7493 11.4605 12.9493 12.275C12.1493 13.0896 12.1611 14.3984 12.9756 15.1984C13.7902 15.9984 15.099 15.9866 15.899 15.1721Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon (2).423996b2256813fd18ad2e62270f9f00.svg";
export { ForwardRef as ReactComponent };